document.addEventListener('DOMContentLoaded', function(){
  const tabProductPill = document.querySelectorAll("[data-product-pill]");
  const swiper = new Swiper('.banner-counter__image-slider-js', {
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
  tabProductPill.forEach(button => {
    button.addEventListener("click", function() {
      button.closest('.banner-counter__text-pills').querySelector('button.active').classList.remove('active');
      button.classList.add('active');
      let active_color = button.getAttribute('data-product-pill');
      let textEl = button.closest('.banner-counter__text-pills').querySelector('[data-product-text]');
      textEl.innerText = active_color;

      const targetImage = document.querySelectorAll(`.banner-counter__image-slider img`);
      targetImage.forEach(image => {
        if(image.getAttribute('alt') === active_color){
          image.style.display = 'block';
        }else{
          image.style.display = 'none';
        }
      })
      swiper.update();
    });
  })
  new Swiper('.related-products-swiper', {
    slidesPerView: 2.5,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    breakpoints: {
      500: {
        slidesPerView: 3.2,
        spaceBetween: 16
      },
      800: {
        slidesPerView: 4,
        spaceBetween: 24
      }
    }
  });
  let swiperProduct;
  window.swiperProduct = new Swiper('.product__media-list', {
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });
})

